"use client";

import { FC } from "react";
import { SwiperSlide } from "swiper/react";

import Carousel from "apps/website/components/feature/Carousel/Carousel";
import Image, { IImage } from "apps/website/components/base/Image/Image";

interface IStyleOptions {
  aspectRatio?: string;
  cover?: boolean;
}
export interface IImageCarousel {
  images: IImage[]
  styleOptions?: IStyleOptions
}

const ImageCarousel: FC<IImageCarousel> = ({ images, styleOptions = {} }) => {
  const { aspectRatio, cover = false } = styleOptions;

  const aspectRatioClass = aspectRatio ? `aspect-[${aspectRatio}]` : undefined;

  return (
    <Carousel component="ImageCarousel" breakpoints={{ default: 1 }} pagination={false} navigationStyle="secondary">
      { images.map((image) => (
        <SwiperSlide key={`image-${image.alt}`} className={aspectRatioClass} >
          <Image {...image} alt={image.alt} cover={cover} />
        </SwiperSlide>
      )) }
    </Carousel>
  );
};

export default ImageCarousel;
